import React, { useEffect } from 'react'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import Slider from '../components/slider/Slider'
import PopularList from '../components/layouts/PopularList'
import NewList from '../components/layouts/NewList'
import useHomeStore from '../stores/homeStore'

const Home = () => {
    const { fetchHeroSliderData, fetchPopularItems, fetchNewItems, fetchBundles, sliders, popularItems, newItems } =
        useHomeStore()

    useEffect(() => {
        const fetchAllData = async () => {
            await Promise.all([fetchHeroSliderData(), fetchPopularItems(), fetchNewItems(), fetchBundles()])
        }
        fetchAllData()
    }, [])

    return (
        <div className="home-1">
            <Header />
            <Slider data={sliders} />
            {/*<PopularList data={popularItems} />
            <NewList data={newItems} />*/}
            <Footer />
        </div>
    )
}

export default Home
